<script setup>

    const props = defineProps({
        progress: {
            default: '0'
        },
        label: {
            type: Boolean,
            default: true
        }
    })

</script>

<template>

    <div v-if="label" class="mb-1 text-sm font-semibold">
        {{ progress }}% Complete
    </div>

    <div class="w-full border-spacing-1.5 border border-lifeworx-blue-400 rounded-md p-0.5 h-4 items-center justify-center">
        <div class="w-full bg-lifeworx-blue-600 bg-opacity-10 rounded-md h-2.5">
            <div class="bg-lifeworx-blue-600 h-2.5 rounded-md" :style="'width: ' + progress + '%;'"></div>
        </div>
        <div class="relative -top-3">
            <div class="grid grid-cols-4 h-3 divide-x-2 divide-white divide-opacity-50">
                <div class="h-full"></div>
                <div class="h-full"></div>
                <div class="h-full"></div>
                <div class="h-full"></div>
            </div>
        </div>
    </div>

</template>
